import script from "./ImageViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageViewer.vue?vue&type=script&setup=true&lang=js"

import "./ImageViewer.vue?vue&type=style&index=0&id=33d8d970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d8d970"]])

export default __exports__